<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <div class="card">
        <p class="title">Price List</p>
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Sku</th>
              <th>Web Price</th>
              <th>1-49</th>
              <th>50-99</th>
              <th>100-499</th>
              <th>500+</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in inventory">
              <tr @click='details = item' class='row-hover' :key="i" :class="{ grey: i % 2 }">
                <td data-label="Item">
                  <div class="img-text">
                    <img
                      class="thumb"
                      :src="require('@/assets/img/kiosk.png')"
                    />{{ item.name }}
                  </div>
                </td>
                <td data-label="Web Price">{{ item.sku }}</td>
                <td data-label="Web Price">
                  {{ formatter.format(item.original_price) }}
                </td>
                <td data-label="10-50">
                  <p>
                    {{ formatter.format(item.prices["1_49"])
                    }}<span class="per">per unit</span>
                  </p>
                  <p class="percent">
                    {{ calculateDiscount(item, item.prices["1_49"]) }} % off
                  </p>
                </td>
                <td data-label="50-99">
                  <p>
                    {{ formatter.format(item.prices["50_99"]) }}
                    <span class="per">per unit</span>
                  </p>
                  <p class="percent">
                    {{ calculateDiscount(item, item.prices["50_99"]) }}% off
                  </p>
                </td>
                <td data-label="100-499">
                  <p>
                    {{ formatter.format(item.prices["100_499"]) }}
                    <span class="per">per unit</span>
                  </p>
                  <p class="percent">
                    {{ calculateDiscount(item, item.prices["100_499"]) }}% off
                  </p>
                </td>
                <td data-label="500+">
                  <p>
                    {{ formatter.format(item.prices["500_"]) }}
                    <span class="per">per unit</span>
                  </p>
                  <p class="percent">
                    {{ calculateDiscount(item, item.prices["500_"]) }}% off
                  </p>
                </td>
              </tr>
              <transition :key="i" name="fade">
                <tr v-if="details == item.sku" :class="{ grey: i % 2 }">
                  <td colspan="100%" class="info">
                    <div>
                      <img class="item-img" src="@/assets/img/kiosk.png" />
                      <div class="specs">
                        <p class="spec">
                          Manufacture
                          <span>{{ item.man_name }}</span>
                        </p>
                        <p class="spec">
                          Color
                          <span>{{ item.color }}</span>
                        </p>
                        <p class="spec">
                          SKU
                          <span>{{ item.sku }}</span>
                        </p>
                        <p class="spec">
                          Size
                          <span>{{ item.size }}</span>
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </transition>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <popup :kiosk='details'></popup>
  </div>
</template>

<script>
import KioskPopup from "@/components/KioskPopup";
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;

export default {
  name: "loginregister",
  components: {
    'popup': KioskPopup,
  },
  data() {
    return {
      details: null,
      user: this.$store.state.reseller,
      inventory: [],
      formatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }),
    };
  },
  firestore() {
    return {
      inventory: db
        .collection("reseller_profile")
        .doc(this.user.id)
        .collection("products"),
    };
  },
  mounted() {},
  created() {},
  updated() {},
  methods: {
    calculateDiscount(product, discount) {
      let retail = product.original_price;
      return Math.round(((discount - retail) / retail) * 100);
    },
    activate(item) {
      if (this.details == item) {
        this.details = null;
      } else {
        this.details = item;
      }
    },
  },
};
</script>

<style lang="scss">
.percent {
  color: #49c6d4;
  font-weight: bold;
  margin-top: -10px;
  margin-bottom: 0;
}

.per {
  font-size: 13px;
  display: block;
  margin-top: -3px;
}

.row-hover {
  transition: background-color .3s;
  cursor: pointer;
  &:hover {
    background-color: rgba(73, 198, 212, 0.15);
  }
  p {
    margin-top: 0;
  }
}
</style>
